import { Link, useLocation, useNavigate } from "react-router-dom";
import Icon from "./Icon";
import { supabase } from "../supabaseClient";
import { useDispatch } from "react-redux";
import { setUser } from "../slices/userReducer";
import LanguageIcon from "../assets/Language.svg";
import { useEffect } from "react";
import { trackPageViewAnalytics } from "../utils/visitorTracking";

export default function ProfileSidebar({ user, language, setLanguage }) {
  const currentPath = useLocation().pathname;

  const navigate = useNavigate();

  const dispatch = useDispatch();

  // Track page view analytics when ProfileSidebar is rendered
  useEffect(() => {
    trackPageViewAnalytics('ACCOUNT', user?.id || null);
  }, [user?.id]);

  const logout = () => {
    supabase.auth.signOut();
    dispatch(
      setUser({
        loading: false,
        id: "",
        email: "",
        first_name: "",
        last_name: "",
        phone_number: "",
        date_of_birth: "",
        location: "",
        gender: "",
        token: "",
        created_at: "",
        role: "",
        genres: "",
        user_info_id: "",
      })
    );
    navigate("/login");
  };

  return (
    <div className="flex lg:flex-row max-lg:flex-col items-center max-lg:pt-12">
      <div className="lg:w-full max-lg:w-[90%]">
        <div className="lg:hidden">
          <h3 className="text-[26px] text-white">Profiel</h3>
        </div>
        <Link
          className={`lg:hidden mt-12 flex items-center justify-between ${
            currentPath === "/profile/me" ? "bg-[#180933]" : ""
          }`}
          to="/profile/me"
        >
          <div className="flex justify-start items-center gap-4">
            <div className="bg-gray-300 p-4 rounded-full">
              <Icon icon="heroicons:user" className="w-10 h-10 text-black" />
            </div>
            <div>
              <h4 className="text-[16px] text-white leading-[22px]">
                {user.first_name}
              </h4>
              <p className="text-[14px] text-purple-300 leading-[20px]">
                Bekijk profiel
              </p>
            </div>
          </div>
          <Icon
            icon="heroicons:chevron-right"
            className="w-10 h-10 text-gray-200"
          />
        </Link>
        <hr className="lg:hidden mt-[30px] border-[#302640]" />
        <div className="mt-[30px]">
          <Link
            className={`max-lg:hidden rounded-lg mt-[12px] flex items-center justify-between ${
              currentPath === "/profile/me" ? "bg-[#D0ADFB20]" : ""
            }`}
            to="/profile/me"
          >
            <div className="flex justify-start items-center max-lg:gap-4">
              <div className="lg:p-6 max-lg:p-4">
                <Icon
                  icon="heroicons:user-circle"
                  className="w-10 h-10 text-gray-200"
                />
              </div>
              <div>
                <h4 className="text-[18px] text-white leading-[22px]">
                  Account
                </h4>
              </div>
            </div>
            <Icon
              icon="heroicons:chevron-right"
              className="lg:hidden w-10 h-10 text-gray-200"
            />
          </Link>
          <Link
            to="/profile/prizes"
            className={`rounded-lg mt-[12px] flex items-center justify-between ${
              currentPath === "/profile/prizes" ? "active" : ""
            }`}
          >
            <div className="flex justify-start items-center max-lg:gap-4">
              <div className="lg:p-6 max-lg:p-4">
                <Icon
                  icon="heroicons:gift"
                  className="w-10 h-10 text-gray-200"
                />
              </div>
              <div>
                <h4 className="text-[18px] text-white leading-[22px]">
                  My Discount Codes
                </h4>
              </div>
            </div>
            <Icon
              icon="heroicons:chevron-right"
              className="lg:hidden w-10 h-10 text-gray-200"
            />
          </Link>
          <Link
            className={`rounded-lg mt-[12px] flex items-center justify-between ${
              currentPath === "/profile/alerts" ? "bg-[#D0ADFB20]" : ""
            }`}
            to="/profile/alerts"
          >
            <div className="flex justify-start items-center max-lg:gap-4">
              <div className="lg:p-6 max-lg:p-4">
                <Icon
                  icon="heroicons:bell-alert"
                  className="w-10 h-10 text-gray-200"
                />
              </div>
              <div>
                <h4 className="text-[18px] text-white leading-[22px]">
                  Ticket alerts
                </h4>
              </div>
            </div>
            <Icon
              icon="heroicons:chevron-right"
              className="lg:hidden w-10 h-10 text-gray-200"
            />
          </Link>
          <Link
            to="https://linktr.ee/22nightmember"
            className="flex justify-between items-center mt-[12px]"
            target="_blank"
          >
            <div className="flex justify-start items-center max-lg:gap-4">
              <div className="lg:p-6 max-lg:p-4">
                <Icon
                  icon="heroicons:key"
                  className="w-10 h-10 text-gray-200"
                />
              </div>
              <div>
                <h4 className="text-[18px] text-white leading-[22px]">
                  Invite friends
                </h4>
              </div>
            </div>
            <Icon
              icon="heroicons:chevron-right"
              className="lg:hidden w-10 h-10 text-gray-200"
            />
          </Link>
          <Link
            className="flex justify-between items-center mt-[12px]"
            to="https://wa.me/31617476764"
            target="_blank"
          >
            <div className="flex justify-start items-center max-lg:gap-4">
              <div className="lg:p-6 max-lg:p-4">
                <Icon
                  icon="heroicons:chat-bubble-left-ellipsis"
                  className="w-10 h-10 text-gray-200"
                />
              </div>
              <div>
                <h4 className="text-[18px] text-white leading-[22px]">
                  Support
                </h4>
              </div>
            </div>
            <Icon
              icon="heroicons:chevron-right"
              className="lg:hidden w-10 h-10 text-gray-200"
            />
          </Link>
          <Link
            className="flex justify-between items-center mt-[12px]"
            to="/faq"
          >
            <div className="flex justify-start items-center max-lg:gap-4">
              <div className="lg:p-6 max-lg:p-4">
                <Icon
                  icon="heroicons:question-mark-circle"
                  className="w-10 h-10 text-gray-200"
                />
              </div>
              <div>
                <h4 className="text-[18px] text-white leading-[22px]">FAQ</h4>
              </div>
            </div>
            <Icon
              icon="heroicons:chevron-right"
              className="lg:hidden w-10 h-10 text-gray-200"
            />
          </Link>
          <div className="lg:hidden flex items-center gap-[16px] mt-[12px] pl-[1rem] w-full">
            <img
              src={LanguageIcon}
              alt="Language"
              className="w-[30px] w-fit h-[30px] text-white"
            />
            <select
              value={"language"}
              onChange={(e) => {
                setLanguage(e.target.value);
              }}
              className="bg-transparent !border-none rounded-lg !outline-none w-full font-normal !text-white text-[16px] appearance-none cursor-pointer"
            >
              <option value="language" disabled>
                Language
              </option>
              <option value="nl">Nederlands</option>
              <option value="en">English</option>
            </select>
          </div>

          <button
            className="flex justify-between items-center mt-[12px] w-full"
            onClick={logout}
          >
            <div className="flex justify-start items-center max-lg:gap-4">
              <div className="lg:p-6 max-lg:p-4">
                <Icon
                  icon="heroicons:arrow-left-on-rectangle"
                  className="w-10 h-10 text-gray-200"
                />
              </div>
              <div>
                <h4 className="text-[18px] text-white leading-[22px]">
                  Logout
                </h4>
              </div>
            </div>
            <Icon
              icon="heroicons:chevron-right"
              className="lg:hidden w-10 h-10 text-gray-200"
            />
          </button>
        </div>
      </div>
    </div>
  );
}
